import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Divider, Button } from '@mui/material';

const LAST_UPDATED = '2026-05-28';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        {t('legal.terms.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {t('legal.lastUpdated')}: {LAST_UPDATED}
      </Typography>
      <Divider sx={{ my: 3 }} />

      <Section title={t('legal.terms.section1.title')}>
        {t('legal.terms.section1.body')}
      </Section>

      <Section title={t('legal.terms.section2.title')}>
        {t('legal.terms.section2.body')}
      </Section>

      <Section title={t('legal.terms.section3.title')}>
        {t('legal.terms.section3.body')}
      </Section>

      <Section title={t('legal.terms.section4.title')}>
        {t('legal.terms.section4.body')}
      </Section>

      <Section title={t('legal.terms.section5.title')}>
        {t('legal.terms.section5.body')}
      </Section>

      <Section title={t('legal.terms.section6.title')}>
        {t('legal.terms.section6.body')}
      </Section>

      <Box mt={4}>
        <Button component={Link} to="/login" variant="outlined">
          {t('legal.backToLogin')}
        </Button>
      </Box>
    </Container>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" gutterBottom fontWeight={600}>
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
      {children}
    </Typography>
  </Box>
);

export default TermsPage;
